import { env } from '@env';
import { httpUtil } from '@/framework';
import { GetCustomerChartRequest, GetCustomerTotalChartResponse } from './Types';

export const getCustomerNewChart = httpUtil.createHttpRequestMeta<
    GetCustomerChartRequest,
    GetCustomerTotalChartResponse
>({
    baseUrl: env.orgServer,
    path: '/customers/new-chart',
    method: 'GET',
    authentication: 'bearer'
});
